import React from 'react';
import { DEFAULT_CHART_PRICE_TYPE, type ChartPriceType } from '../../../lib/tradingViewHelpers';
import { MultiSelect } from '../../MultiSelect/MultiSelect';
import { TriggerWithChevron } from './TriggerWithChevron';

const priceOptions = [
  {
    value: 'last-price',
    label: 'Last Traded Price',
  } as const,
  {
    value: 'oracle-price',
    label: 'Oracle Price',
  } as const,
];

interface ChartPriceSettingsProps {
  priceType: ChartPriceType;
  setPriceType: (priceType: ChartPriceType) => void;
}

export const ChartPriceSettings: React.FC<ChartPriceSettingsProps> = ({
  priceType,
  setPriceType,
}) => {
  const handleChange = (value: ChartPriceType | undefined) => {
    if (value) {
      setPriceType(value);
    }
  };

  const selectedOption =
    priceOptions.find((option) => option.value === priceType) ??
    priceOptions.find((opt) => opt.value === DEFAULT_CHART_PRICE_TYPE);

  return (
    <MultiSelect
      multiselect={false}
      options={priceOptions}
      value={priceType}
      onChange={handleChange}
      triggerComponent={({ disabled, ref, isOpen, ...props }) => (
        <TriggerWithChevron
          ref={ref}
          disabled={disabled}
          isOpen={isOpen}
          title="Toggle Chart Price Settings"
          {...props}
        >
          {selectedOption?.label}
        </TriggerWithChevron>
      )}
      triggerLabel="Price"
      showSearchInput={false}
    />
  );
};
